<template>
  <div class="ui special cards">
    <div class="ui one column grid">
      <div class="column">
        <div class="card">
          <div class="blurring dimmable image">
            <div class="ui dimmer">
              <div class="content">
                <div class="center">
                  <input type="file" id="image" style="display:none;float:left" @change="onFileChangeForCreate">
                  <label for="image" class="ui inverted button">
                    <i class="ui upload icon"></i>
                    {{ $t('chooseImage') }}
                  </label>
                </div>
              </div>
            </div>

            <img :src="getImageSrc()"
                  style="height:250px; object-fit: contain"
                  v-if="!object.album || (object.album && object.album.images.length < 1 )|| current_image"/>
            <img :src="getImage()"
                 style="height:250px; object-fit: contain"
                 v-else />
          </div>
          <div class="ui bottom attached mini buttons" v-if="current_image !== null"
               >
            <div class="ui button" @click="sendImage()" :class="{loading: isButtonLoading}">
              <i class="add icon"></i>
              {{ $t('save') }}
            </div>
            <div class="ui red button" @click="discardImage()" :class="{loading: isButtonLoading}"> 
              <i class="trash icon"></i>
              {{ $t('discard') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sendingURL: { type: String, required: true },
    object: { type: Object, required: true },
    params: { type: Object, default: () => {} },
    imageCallBack: { type: Function, default: () => { return null; } }
  },
  data () {
    return {
      image: {
        picture: {
          content: new Image()
        }
      },
      current_image: null,
      isButtonLoading: false
    }
  },
  mounted () {
    this.initSpecialCards()
  },
  methods: {
    getImageSrc () {
      if (this.current_image) {
        return this.current_image
      } else {
        return require('@/assets/image.png')
      }
    },
    onFileChangeForCreate (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      this.current_image = null
      reader.onload = (e) => {
        this.image.picture.content = e.target.result
        this.current_image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    sendImage () {
      let imageToSaved = {
        picture: this.image.picture.content
      }

      if (this.isButtonLoading) return 
      
      this.isButtonLoading = true
      this.$http.post(`${this.sendingURL}`, { ...this.params, image: imageToSaved }).then(response => {
        this.object.album = response.data
        this.imageCallBack(response.data)
        this.discardImage()
        this.isButtonLoading = false
      })
    },
    getImage () {
      return this.object.album && this.object.album.images[this.object.album.images.length - 1].picture.url
    },
    initSpecialCards () {
      this.$nextTick(() => {
        $('.special.cards .image').dimmer({
          on: 'hover'
        })
      })
    },
    discardImage () {
      this.current_image = null
      this.image.picture.content = new Image()
    }
  }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/abstract_components/Image.vue